"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApFooter = void 0;
var React = require("react");
var ApLogo_1 = require("../ApLogo");
var styles_1 = require("./styles");
exports.ApFooter = function (_a) {
    var isFluid = _a.isFluid, right = _a.right, alignItems = _a.alignItems, padding = _a.padding, className = _a.className;
    var fullYear = new Date().getFullYear();
    return (React.createElement(styles_1.StyledApFooter, { padding: padding, className: "ap-footer " + (className ? className : '') },
        React.createElement(styles_1.StyledApFooterInner, { isFluid: isFluid },
            React.createElement(styles_1.StyledApFooterRow, null,
                React.createElement(styles_1.StyledApFooterLeftContent, { alignItems: alignItems },
                    React.createElement(ApLogo_1.ApLogo, { theme: "dark" })),
                right && (React.createElement(styles_1.StyledApFooterRightContent, { alignItems: alignItems }, right()))),
            React.createElement(styles_1.StyledApFooterRow, null,
                React.createElement(styles_1.StyledApFooterDisclaimer, null,
                    "\u00A9 ",
                    fullYear,
                    " AlixPartners, LLP. AlixPartners is not a certified public accounting firm and is not authorized to practice law or provide legal services.",
                    React.createElement("br", null),
                    "*Registered Name: AlixPartners UK LLP | Registered Address: 6 New Street Square London, EC4A 3BF United Kingdom | Registration Number: OC360308 | Place of Registration: England & Wales")))));
};
exports.ApFooter.defaultProps = {
    alignItems: 'center',
    isFluid: false
};
//# sourceMappingURL=ApFooter.js.map